// extracted by mini-css-extract-plugin
export default {"row":"Section_row__brkxk","row_full":"Section_row_full__GGT0P"};